// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyC5mLc6BG89P2su4mgVe0PKyPX8IawAyXY',
    authDomain: 'zebra-f917c.firebaseapp.com',
    databaseURL: 'https://zebra-f917c.firebaseio.com',
    projectId: 'zebra-f917c',
    storageBucket: 'zebra-f917c.appspot.com',
    messagingSenderId: '689128917092'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
